'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.enableSearch = enableSearch;
var ENABLE_SEARCH = exports.ENABLE_SEARCH = 'ENABLE_SEARCH';

function enableSearch() {
    var shouldEnableSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return function (dispatch) {
        dispatch({ type: ENABLE_SEARCH, enableSearch: shouldEnableSearch });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/web/actions/launch-darkly.js
// module id = 789
// module chunks = 0